import React, { useState } from 'react';
import { FiGlobe } from 'react-icons/fi';
import Toggle from '../../../Toggle';

export type PublishWhen = 'now' | 'schedule' | 'draft';

const WHEN: { value: PublishWhen; title: string; hint: string }[] = [
    { value: 'now', title: 'Publish now', hint: 'Live on the website as soon as you click Publish' },
    { value: 'schedule', title: 'Schedule for later', hint: 'Pick a date and time' },
    { value: 'draft', title: 'Keep as draft', hint: 'Only your team can see it' },
];

const EXTRAS = [
    { key: 'latest', title: 'Show in “Latest news” on the home page', hint: 'Up to 3 newest articles', on: true },
    { key: 'email', title: 'Also send as an email campaign', hint: 'Opens New campaign with this article', on: false },
    { key: 'social', title: 'Share on LinkedIn and X', hint: 'Opens New post after publishing', on: false },
];

// Publishing card on every add / edit page (spec 409:10781, right column)
const PublishingCard: React.FC<{ when: PublishWhen; onWhen: (w: PublishWhen) => void }> = ({ when, onWhen }) => {
    const [extras, setExtras] = useState<Record<string, boolean>>(() => Object.fromEntries(EXTRAS.map(x => [x.key, x.on])));
    const [at, setAt] = useState('');

    return <section className="card hub-publishing">
        <div className="section-title"><span className="icon-tile"><FiGlobe /></span><h2>Publishing</h2></div>
        <div className="options" role="radiogroup" aria-label="When it goes live">
            {WHEN.map(w => <button key={w.value} type="button" role="radio" aria-checked={when === w.value}
                className={`option${when === w.value ? ' selected' : ''}`} onClick={() => onWhen(w.value)}>
                <span className="radio" />
                <span className="text"><strong>{w.title}</strong><span>{w.hint}</span></span>
            </button>)}
        </div>
        {when === 'schedule' && <label className="field">
            <span className="label">Goes live on</span>
            <input type="datetime-local" value={at} onChange={e => setAt(e.target.value)} />
        </label>}
        <div className="hub-news-toggles">
            {EXTRAS.map(x => <div key={x.key} className="setting-row">
                <div className="text"><div className="title">{x.title}</div><div className="hint">{x.hint}</div></div>
                <Toggle label={x.title} checked={extras[x.key]} onChange={v => setExtras(s => ({ ...s, [x.key]: v }))} />
            </div>)}
        </div>
    </section>;
};

export default PublishingCard;
